import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-request-by-items",
  templateUrl: "./request-by-items.component.html",
  styleUrls: ["./request-by-items.component.css"]
})
export class RequestByItemsComponent implements OnInit {
  itemsRequests: any[] = [];
  constructor(private router: Router) {}

  ngOnInit(): void {
    // this.itemsRequests = this.router.getCurrentNavigation().extras.state.data;
  }
}
